/**
 * Swatch King Fix - Prevents Add to Cart button from being hidden on swatch selection
 */
(function() {
  // Function to ensure Add to Cart button remains visible
  function keepAddToCartButtonVisible() {
    console.log('Running Swatch King Fix');
    // Target add to cart buttons that might be affected
    const addToCartButtons = document.querySelectorAll('[name="add"], .product-form__submit, .add-to-cart');
    
    if (addToCartButtons.length) {
      addToCartButtons.forEach(button => {
        // Ensure visibility by monitoring style changes
        const observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
            if (mutation.attributeName === 'style' && 
                (button.style.display === 'none' || button.style.visibility === 'hidden')) {
              // Restore button visibility
              button.style.display = '';
              button.style.visibility = '';
              button.style.opacity = '1';
            }
          });
        });
        
        // Start observing the button
        observer.observe(button, { attributes: true });
        
        // Also ensure visibility after swatch clicks
        document.addEventListener('click', function(e) {
          if (e.target && (e.target.classList.contains('swatch-view-item') || 
              e.target.closest('.swatch-view-item'))) {
            // Short delay to let Swatch King app execute first
            setTimeout(() => {
              button.style.display = '';
              button.style.visibility = '';
              button.style.opacity = '1';
            }, 10);
          }
        });
      });
    }
  }

  // Run on page load and after any content changes
  document.addEventListener('DOMContentLoaded', keepAddToCartButtonVisible);
  document.addEventListener('page:loaded', keepAddToCartButtonVisible);
  
  // Also check for dynamically loaded content
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        keepAddToCartButtonVisible(); // Fixed: Added parentheses to call the function
      }
    }
  });
  
  // Start observing document body for changes
  observer.observe(document.body, { childList: true, subtree: true });
})();